module.exports = __webpack_public_path__ + "static/media/breadcrumb_back.343f9203.svg";